/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import { WingBlank, WhiteSpace, Tag } from "antd-mobile";
import PropTypes from "prop-types";
import { FaListUl, FaThLarge, FaCaretDown, FaInfoCircle } from "react-icons/fa";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import BannerItem from "../../components/BannerItem/index";
import ProductListing from "../../components/ProductListing";
import FilterModal from "./FilterModal";
import * as selectors from "../../selectors";
import * as stallAction from "../../actions/stall";
import * as foodAction from "../../actions/food";
import * as stallSelectors from "../../selectors/stall";
import * as fitlerSelectors from "../../selectors/filter";
import * as _ from "underscore";
import LoadingIndicator from "../../components/LoadingIndicator";
import InfoModal from "../../components/InfoModal/index";
import Theme from "../../utils/Theme";
import "./index.css";

const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
`;

const StyledHeaderMainContainer = styled.div`
  padding: 0 15px;
`;

const StyledSpaceBetweenContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
`;

const StyledFilterContainer = styled.div`
  cursor: pointer
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const StyledInfoContainer = styled.div`
  cursor: pointer
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

const StyledFilterTitle = styled.span`
  font-size: 0.9em;
`;

const StyledListTypeContainer = styled.div`
  cursor: pointer;
`;

const StyledAppliedFilterContainer = styled.div`
  margin-bottom: 10px;
  padding: 10px 0 10px 20px;
  background: white;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border-top: 0.5px solid lightgray;
  border-bottom: 0.5px solid lightgray;
  box-shadow: 0 2px 6px -5px grey;
`;

const StyledAppliedFilterContentContainer = styled.div`
  flex: 85;
  margin-left: 15px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  overflow-x: scroll;
  overflow-y: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const StyledClearFilterTitle = styled.span`
  flex: 15;
  cursor: pointer;
  color: ${Theme.PrimaryColor};
  font-size: 0.9em;
  &:hover {
    opacity: 0.5;
    text-decoration: underline;
  }
`;

const StyledStallClosed = styled.div`
  color: #fff;
  background: red;
  padding: 3px;
  font-size: 0.8em;
`;

function closest(el, selector) {
  const matchesSelector =
    el.matches ||
    el.webkitMatchesSelector ||
    el.mozMatchesSelector ||
    el.msMatchesSelector;
  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

class StallPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      animationClass: null,
      horizontalView: false,
      filterModal: false,
      infoModal: false
    };
  }

  componentDidMount() {
    const { match } = this.props;
    const stallID = match && match.params ? match.params.id : null;

    this.configureNavBar();
    this.fetchStallDetailItemData(stallID);
    this.fetchStallFoodData(stallID);
    this.setState({ animationClass: "slide-in-right" });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { match } = this.props;
    const stallID = match && match.params ? match.params.id : null;

    if (this.props.stallDetailData !== nextProps.stallDetailData) {
      const title = stallSelectors.getStallItemName(nextProps.stallDetailData);
      this.configureNavBar(title);
    }

    if (this.props.selectedFilterData !== nextProps.selectedFilterData) {
      this.fetchStallFoodData(stallID);
    }
  }

  componentWillUnmount() {
    const { setFilterData, match } = this.props;
    const stallID = match && match.params ? match.params.id : null;

    setFilterData(stallID, null);
  }

  onBackPressed = () => {
    const { history } = this.props;
    this.setState({ animationClass: "slide-out-right" });

    window.setTimeout(() => {
      history.goBack();
    }, 300);
  };

  configureNavBar = (title = null) => {
    const { navbarConfig, showTabbar, showNavbar } = this.props;
    const navTitle = title ? (
      title
    ) : (
      <span>
        <FormattedMessage id="app.loading" />
        ...
      </span>
    );

    const navDescription = (
      <StyledInfoContainer onClick={e => this.showInfoModal(e)}>
        <FaInfoCircle size={"1.1em"} />
      </StyledInfoContainer>
    );

    navbarConfig(
      navTitle,
      null,
      navDescription,
      () => this.onBackPressed(),
      null
    );
    showNavbar(true);
    showTabbar(false);
  };

  fetchStallDetailItemData = stallID => {
    const { getStallDetailRequest } = this.props;

    getStallDetailRequest(stallID);
  };

  fetchStallFoodData = (stallID, pageNumber = 1, hideLoding = false) => {
    const { getStallFoodDataRequest } = this.props;

    getStallFoodDataRequest(stallID, pageNumber, hideLoding);
  };

  getBanner = () => {
    const { stallDetailData } = this.props;
    const banner = {
      src:
        stallDetailData && stallDetailData.image && stallDetailData.image.banner
          ? stallDetailData.image.banner.src
          : "https://via.placeholder.com/400x300",
      category:
        stallDetailData && stallDetailData.category
          ? stallDetailData.category.short_name
          : null,
      title: stallDetailData ? stallDetailData.name : null,
      review:
        stallDetailData && stallDetailData.review
          ? stallDetailData.review.rating
          : 0,
      reviewCount:
        stallDetailData && stallDetailData.review
          ? stallDetailData.review.count
          : 0
    };

    return stallDetailData ? (
      <BannerItem
        src={banner.src}
        itemKey={"banner-" + banner.title}
        category={banner.category}
        title={banner.title}
        review={banner.review}
        reviewCount={banner.reviewCount}
      />
    ) : null;
  };

  getMenuBar = () => {
    const { horizontalView } = this.state;

    return (
      <StyledSpaceBetweenContainer>
        <StyledFilterContainer onClick={e => this.showModal(e)}>
          <StyledFilterTitle>
            <FormattedMessage
              id="stall.filter.title"
              defaultMessage="Smart Filter"
              description="Filter Label Title"
            />
          </StyledFilterTitle>
          <WingBlank size={"sm"} />
          <FaCaretDown size={"1.1em"} />
        </StyledFilterContainer>
        <StyledListTypeContainer
          onClick={() => this.setState({ horizontalView: !horizontalView })}
        >
          {horizontalView ? (
            <FaThLarge size={"1.3em"} />
          ) : (
            <FaListUl size={"1.3em"} />
          )}
        </StyledListTypeContainer>
      </StyledSpaceBetweenContainer>
    );
  };

  getFormattedFilterData = () => {
    const { selectedFilterData } = this.props;
    const filterDataMinPrice = fitlerSelectors.getFilterDataMinPrice(
      selectedFilterData
    );
    const filterDataMaxPrice = fitlerSelectors.getFilterDataMaxPrice(
      selectedFilterData
    );
    const filterDataMaxEta = fitlerSelectors.getFilterDataEtaTime(
      selectedFilterData
    );

    let formattedPrice = null;
    if (filterDataMinPrice && filterDataMaxPrice) {
      formattedPrice =
        filterDataMinPrice && filterDataMaxPrice
          ? `RM ${filterDataMinPrice} - RM ${filterDataMaxPrice}`
          : null;
    }
    if (!filterDataMinPrice && filterDataMaxPrice) {
      formattedPrice = filterDataMaxPrice ? `< RM ${filterDataMaxPrice}` : null;
    }

    let formattedEta = filterDataMaxEta ? `< ${filterDataMaxEta} mins` : null;

    let formattedData = [];
    if (!_.isEmpty(formattedPrice)) {
      let newItem = {
        text: formattedPrice
      };
      formattedData.push(newItem);
    }
    if (!_.isEmpty(formattedEta)) {
      let newItem = {
        text: formattedEta
      };
      formattedData.push(newItem);
    }
    selectedFilterData &&
      selectedFilterData.foodTag.map(item => {
        let newItem = {
          text: item.name
        };
        formattedData.push(newItem);
      });

    return formattedData;
  };

  getAppliedFilterBar = () => {
    const formattedSelectedFilterData = this.getFormattedFilterData();

    if (!_.isEmpty(formattedSelectedFilterData)) {
      return (
        <StyledAppliedFilterContainer>
          <StyledClearFilterTitle onClick={() => this.onClearFilters()}>
            <FormattedMessage
              id="app.clear.all"
              defaultMessage="Clear all"
              description="Clear Filter Title"
            />
          </StyledClearFilterTitle>
          <StyledAppliedFilterContentContainer>
            {formattedSelectedFilterData.map((tag, index) => (
              <div
                key={index}
                style={{ display: "flex", flexDirection: "row" }}
              >
                <WingBlank size={"sm"} />
                <Tag className={"filter-tag"}>{tag.text}</Tag>
              </div>
            ))}
          </StyledAppliedFilterContentContainer>
        </StyledAppliedFilterContainer>
      );
    }

    return null;
  };

  getHeader = () => {
    const { isAvailable } = this.props;
    return (
      <div>
        <StyledHeaderMainContainer>
          {isAvailable ? null : (
            <StyledStallClosed>
              <FormattedMessage
                id="stall.page.close"
                defaultMessage="Closed"
                description="Stall is Closed"
              />
            </StyledStallClosed>
          )}
          {this.getBanner()}
          {this.getMenuBar()}
        </StyledHeaderMainContainer>
        {this.getAppliedFilterBar()}
      </div>
    );
  };

  getLoadingIndicator = () => {
    const {
      stallDetailLoading,
      stallFoodLoading,
      stallFoodHideLoading
    } = this.props;

    if (stallFoodHideLoading) {
      return null;
    }

    if (!stallDetailLoading && !stallFoodLoading) {
      return null;
    }

    return <LoadingIndicator />;
  };

  getFoodDataList = () => {
    const { stallFoodData } = this.props;
    const emptyData = [{ type: "empty" }];

    return stallFoodData && stallFoodData.length > 0
      ? stallFoodData
      : emptyData;
  };

  showModal = e => {
    e.preventDefault();
    this.setState({
      filterModal: true
    });
  };

  showInfoModal = e => {
    e.preventDefault();
    this.setState({
      infoModal: true
    });
  };

  onInfoModalClose = () => {
    this.setState({ infoModal: false });
  };

  onClose = filterResults => {
    const { setFilterData, match } = this.props;
    const stallID = match && match.params ? match.params.id : null;

    setFilterData(stallID, filterResults);
    this.setState({
      filterModal: false
    });
  };

  onClearFilters = () => {
    const { setFilterData, match } = this.props;
    const stallID = match && match.params ? match.params.id : null;

    setFilterData(stallID, null);
  };

  onWrapTouchStart = e => {
    if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
      return;
    }
    const pNode = closest(e.target, ".am-modal-content");
    if (!pNode) {
      e.preventDefault();
    }
  };

  onStallFoodEndReached = () => {
    const { stallFoodPagination, match } = this.props;
    const stallID = match && match.params ? match.params.id : null;

    if (stallFoodPagination) {
      const { pageCount, currentPage } = stallFoodPagination;

      if (currentPage < pageCount) {
        this.fetchStallFoodData(stallID, currentPage + 1, true);
      }
    }
  };

  onPressFavouriteItem = (foodID, isFavourite) => {
    const {
      favouriteFoodRequest,
      unFavouriteFoodRequest,
      authToken,
      history
    } = this.props;

    if (!authToken) {
      history.push("/auth/login");
      return;
    }

    if (isFavourite) {
      favouriteFoodRequest(foodID);
    } else {
      unFavouriteFoodRequest(foodID);
    }
  };

  render() {
    const {
      animationClass,
      horizontalView,
      filterModal,
      infoModal
    } = this.state;
    const {
      stallFoodLoading,
      stallFoodData,
      stallDetailData,
      selectedFilterData
    } = this.props;
    const stallFilterData = stallSelectors.getStallItemFilter(stallDetailData);
    const description = stallSelectors.getStallItemDescription(stallDetailData);
    return (
      <StyledContainer
        className={animationClass !== null ? animationClass : false}
        onAnimationEnd={() => this.setState({ animationClass: null })}
      >
        {this.getLoadingIndicator()}
        <WhiteSpace size={"md"} />
        <FilterModal
          filterData={stallFilterData}
          selectedFilterData={selectedFilterData}
          shouldShow={filterModal}
          onClose={filterResults => {
            this.onClose(filterResults);
          }}
          onTouchStart={this.onWrapTouchStart}
        />
        <InfoModal
          description={description}
          shouldShow={infoModal}
          onInfoModalClose={this.onInfoModalClose}
          onTouchStart={this.onWrapTouchStart}
        />
        <ProductListing
          {...this.props}
          items={this.getFoodDataList()}
          horizontalView={horizontalView}
          renderHeader={() => this.getHeader()}
          onEndReached={this.onStallFoodEndReached}
          showFooterLoading={stallFoodLoading && stallFoodData.length > 0}
          isRefreshing={false}
          onFavouriteClicked={this.onPressFavouriteItem}
        />
        <WhiteSpace size={"md"} />
      </StyledContainer>
    );
  }
}

StallPage.propTypes = {
  showNavbar: PropTypes.func.isRequired,
  showTabbar: PropTypes.func.isRequired,
  navbarConfig: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  authToken: PropTypes.string,
  stallDetailData: PropTypes.object,
  stallDetailLoading: PropTypes.bool,
  stallFoodData: PropTypes.array,
  stallFoodPagination: PropTypes.object,
  stallFoodLoading: PropTypes.bool,
  stallFoodHideLoading: PropTypes.bool,
  selectedFilterData: PropTypes.array,
  getStallDetailRequest: PropTypes.func,
  getStallFoodDataRequest: PropTypes.func,
  favouriteFoodRequest: PropTypes.func,
  unFavouriteFoodRequest: PropTypes.func,
  setFilterData: PropTypes.func
};

function mapStateToProps(state, props) {
  const { match } = props;
  const stallID = match && match.params ? match.params.id : null;

  return {
    authToken: selectors.getAuthToken(state),
    stallDetailData: selectors.getStallDetailItem(state, stallID),
    stallDetailLoading: selectors.getStallDetailLoading(state),
    stallFoodData: selectors.getStallFoodData(state),
    stallFoodPagination: selectors.getStallFoodPagination(state),
    stallFoodLoading: selectors.getStallFoodLoading(state),
    selectedFilterData: selectors.getSelectedFilterData(state, stallID),
    stallFoodHideLoading: selectors.getStallFoodHideLoading(state),
    isAvailable: stallSelectors.getStallIsAvailable(
      selectors.getStallDetailItem(state, stallID)
    )
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getStallDetailRequest: stallID =>
      dispatch(stallAction.getStallDetailRequest(stallID)),
    getStallFoodDataRequest: (stallID, page, hideLoading) =>
      dispatch(foodAction.getStallFoodDataRequest(stallID, page, hideLoading)),
    favouriteFoodRequest: foodID =>
      dispatch(foodAction.favouriteFoodRequest(foodID)),
    unFavouriteFoodRequest: foodID =>
      dispatch(foodAction.unFavouriteFoodRequest(foodID)),
    setFilterData: (stallID, filterData) =>
      dispatch(stallAction.setFilterData(stallID, filterData))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StallPage);



// WEBPACK FOOTER //
// ./src/containers/StallPage/index.js